<template>
  <div>
    <PageTitleVue
      :sub-title="subTitle"
      :key="pageTitle"
      :small="
        pageTitle == 'ESTATISTICAS' ||
        pageTitle == 'SETORES E COMITÊS' ||
        pageTitle == 'REGISTRAR RCD' ||
        pageTitle == 'NOVA UNIDADE' ||
        pageTitle == 'NOVO SETOR' ||
        pageTitle == 'ATUALIZAR UNIDADE' ||
        pageTitle == 'ATUALIZAR SETOR'
        ? true : false"
    >
      {{ pageTitle }}

      <template #b-action>
        <div class="my-1 -mt-1">
          <Transition mode="out-in">

            <!-- relatos -->
            <Create
              v-if="store.getters.getActiveComponent.__name === 'RelatosList'"
              :icon="PhFilePlus"
              :label="'Novo relato'"
              :width-medium="true"
              @click="setFormComponentActive()"
            />
            <Create
              v-else-if="store.getters.getActiveComponent.__name === 'NewRcdForm'"
              :icon="PhArrowLeft"
              :label="'Ver relatos'"
              :width-medium="true"
              @click="setListComponentActive()"
            />

            <!-- unidades -->
            <Create
              v-else-if="store.getters.getActiveComponent.__name === 'UnidadesList'"
              :icon="PhBuildingApartment"
              :label="'Nova unidade'"
              :width-medium="true"
              @click="setComponentActiveFormUnidade()"
            />
            <Create
              v-else-if="
                store.getters.getActiveComponent.__name === 'NewUnidadeForm' ||
                store.getters.getActiveComponent.__name === 'UpdateUnidadeForm'
              "
              :icon="PhArrowLeft"
              :label="'Ver unidades'"
              :width-medium="true"
              @click="setListUnidadeComponentActive()"
            />

            <!-- setores -->
            <Create
              v-else-if="store.getters.getActiveComponent.__name === 'SetoresList'"
              :icon="PhGitBranch"
              :label="'Novo setor'"
              :width-medium="true"
              @click="setComponentActiveFormSector()"
            />
            <Create
              v-else-if="
                store.getters.getActiveComponent.__name === 'NewSectorForm' ||
                store.getters.getActiveComponent.__name === 'UpdateSectorForm'
              "
              :icon="PhArrowLeft"
              :label="'Ver setores'"
              :width-medium="true"
              @click="setComponentActiveListSectors()"
            />

          </Transition>
        </div>
      </template>
    </PageTitleVue>

    <RcdTabs>
      <template #relatos>
        <ListAndFormNewRcd />
      </template>

      <template #cadastros>
        <div class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white">
          <DropDownOptions
            v-model="selectedFilter"
            :label="'OPÇÕES DE CADASTRO'"
            :options="['UNIDADES', 'SETORES']"
          />
        </div>

        <ListAndForms />
      </template>

      <template #statistics>
        <Statistics />
      </template>
    </RcdTabs>
  </div>
</template>

<script setup>
import DropDownOptions from '@/components/Tables/DropDownOptions.vue'
import ListAndForms from './layout/ListAndFormUnidadeAndSectors.vue'
import ListAndFormNewRcd from './layout/ListAndFormNewRcd.vue'
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import RcdTabs from './components/_partials/RcdTabs.vue'
import Statistics from './layout/pages/Statistics.vue'
import Create from '@/components/Buttons/Create.vue'
import RcdService from './service/rcd.service'
import { PhArrowLeft, PhBuildingApartment, PhFilePlus, PhGitBranch } from '@phosphor-icons/vue'
import { onBeforeMount, watch, computed, ref } from 'vue'
import { initFlowbite } from 'flowbite'
import { storeApp } from '@/store'
import { dataRcd } from './store'

import { showToast as toast } from '@/helpers/UseToasts'

const store = dataRcd
const subTitle = ref('')
const selectedFilter = ref('')
const animationOptions = ref({
  animationData: require('@/assets/lotties/404-not found.json'),
  loop: true,
  autoplay: true
})

const isMobile = computed(() => window.innerWidth < 768)

const pageTitle = computed(() => {
  if (store.getters.getActiveComponent.__name == 'RelatosList') {
    subTitle.value = 'Gerencie todos os relatos cadastrados'
    return 'RELATOS'
  }
  if (store.getters.getActiveComponent.__name == 'NewRcdForm') {
    subTitle.value = 'Faça o cadastro de um novo desvio comportamental'
    return 'REGISTRAR RCD'
  }

  if (store.getters.getActiveComponent.__name == 'UnidadesList') {
    subTitle.value = 'Gerencie suas unidades'
    return 'UNIDADES'
  }
  if (store.getters.getActiveComponent.__name == 'NewUnidadeForm') {
    subTitle.value = 'Adicione uma nova unidade para gerenciar'
    return 'NOVA UNIDADE'
  }
  if (store.getters.getActiveComponent.__name == 'UpdateUnidadeForm') {
    subTitle.value = 'Altere os dados desta unidade de maneira facil'
    return 'ATUALIZAR UNIDADE'
  }

  if (store.getters.getActiveComponent.__name == 'SetoresList') {
    subTitle.value = 'Gerencie seus setores e comites'
    return 'SETORES E COMITÊS'
  }
  if (store.getters.getActiveComponent.__name == 'NewSectorForm') {
    subTitle.value = 'Adicione um novo comite para gerenciar o setor'
    return 'NOVO SETOR'
  }
  if (store.getters.getActiveComponent.__name == 'UpdateSectorForm') {
    subTitle.value = 'Altere os dados deste setor de maneira facil'
    return 'ATUALIZAR SETOR'
  }

  if (store.getters.getActiveTab == 'statistics') {
    subTitle.value = 'Tenha uma visão geral e moderna dos seus relatos'
    return 'ESTATISTICAS'
  }
})

// option selected
watch(
  () => selectedFilter.value,
  (newVal) => {
    selectedFilter.value = ''

    if (newVal == 'UNIDADES') { dataRcd.dispatch('setComponentActiveUnidade') }

    if (newVal == 'SETORES') { dataRcd.dispatch('setComponentActiveSectors') }
  },
  { immediate: true }
)

// tabs
watch(
  () => store.getters.getActiveTab,
  (newVal) => {
    if (newVal === 'relatos') { return setListComponentActive() }

    if (newVal === 'cadastros') { return setListUnidadeComponentActive() }

    if (newVal === 'statistics') { return setComponentActiveStatistics() }
  },
  { immediate: true }
)

// reset forms
watch(
  () => store.getters.getActiveComponent.__name,
  (newVal) => {
    if (
      newVal === 'NewUnidadeForm' ||
      newVal === 'NewSectorForm' ||
      newVal === 'NewRcdForm'
    ) { store.dispatch('resetForms') }
    store.dispatch('resetRelatoForm')
  },
  { immediate: true }
)

// define a listagem de relatos
function setListComponentActive () {
  dataRcd.dispatch('setListComponentActive')
}
// defione o form de cadastro de relatos
function setFormComponentActive () {
  dataRcd.dispatch('setFormComponentActive')
}

// define o form de unidades
function setComponentActiveFormUnidade () {
  dataRcd.dispatch('setComponentActiveFormUnidade')
}
function setListUnidadeComponentActive () {
  dataRcd.dispatch('setComponentActiveUnidade')
}

// define o form de setores
function setComponentActiveFormSector () {
  dataRcd.dispatch('setComponentActiveFormSector')
}
function setComponentActiveListSectors () {
  dataRcd.dispatch('setComponentActiveSectors')
}

function setComponentActiveStatistics () {
  dataRcd.dispatch('setComponentActiveStatistics')
}

// pega todos os relatos
async function getAllRelatos () {
  await RcdService.allRelatos()
    .then(res => {
      store.dispatch('setRelatos', res?.data?.relatos)
    }).catch(err => {
      return toast(
        'Aviso',
        'Algo deu errado ao buscar relatos',
        'error'
      )
    })
}

// pega as unidades
async function getUnidades () {
  await RcdService.getAllUnidades()
    .then(res => {
      store.dispatch('setUnidades', res.data.unidades)
    }).catch(err => {
      return toast(
        'Aviso',
        'Algo deu errado ao buscar unidades',
        'error'
      )
    })
}

// pega todos os setores
async function getSetores () {
  await RcdService.getAllSectors()
    .then(res => {
      store.dispatch('setSectors', res.data.setores)
    }).catch(err => {
      return toast(
        'Aviso',
        'Algo deu errado ao buscar setores',
        'error'
      )
    })
}

onBeforeMount(async () => {
  storeApp.state.loading = true
  dataRcd.dispatch('setActiveTab', 'relatos')
  initFlowbite()
  await getAllRelatos()
  storeApp.state.loading = false
  Promise.allSettled([
    await getUnidades(),
    await getSetores()
  ])
})
</script>

<style scoped lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
